import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import getSidebarItems from "../../components/Sidebar/sidebarItems";
import SidebarItem from "../../entities/SidebarItem";
import i18n from "../../i18n";
import { apiCallBegan, ApiCallFailedPayload } from "../api";
import { AppDispatch, AppState } from "../configureStore";
import SliceCollectionBase from "../types/SliceCollectionBase";
import { authHeader } from "../users/auth";

// SLICE //
interface State extends SliceCollectionBase<SidebarItem> {
  itemIds: string[],
  sidebarIsOpen: boolean,
}

const initialState: State = {
  list: [],
  loading: false,
  lastFetch: null,
  error: null,

  itemIds: [],
    sidebarIsOpen: false,
}

const slice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    // SIDEBAR ITEMS
    sidebarRequested: (sidebar) => {
      sidebar.loading = true;
      sidebar.error = null;
    },
    sidebarReceived: (sidebar, action: PayloadAction<string[]>) => {
      sidebar.list = [...getSidebarItems(action.payload)];
      sidebar.loading = false;
      sidebar.lastFetch = Date.now();

      sidebar.itemIds = action.payload;
    },
    sidebarRequestFailed: (sidebar, action: PayloadAction<ApiCallFailedPayload>) => {
      sidebar.loading = false;
      sidebar.error = action.payload;
    },

    // SIDEBAR LOCAL STATE
    sidebarOpen: (sidebar, action: PayloadAction<boolean>) => {
      sidebar.sidebarIsOpen = action.payload;
    }
  }
});

const {
  sidebarRequested,
  sidebarReceived,
  sidebarRequestFailed,

  sidebarOpen
} = slice.actions;

export default slice.reducer;

// ACTION CREATORS //
export const getSidebar = () => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (getState().entities.sidebar.loading) {
    return;
  }

  const url = "/api/Menu/Items";

  return await dispatch(
    apiCallBegan({
      url,
      method: "GET",
      headers: { ...authHeader(), "Accept-Language": i18n.language },
      onStart: sidebarRequested.type,
      onSuccess: sidebarReceived.type,
      onError: sidebarRequestFailed.type
    })
  );
};

export const setIsSidebarOpen = (sidebarIsOpen: boolean) => (dispatch: AppDispatch) =>
  dispatch({ type: sidebarOpen.type, payload: sidebarIsOpen });

